import React, { useEffect, useState } from "react";
import ReactDOM from 'react-dom';
import "../Css/groove_pdf.css";
import { Modal, Button } from "react-bootstrap";
import BarLoader from "react-spinners/BarLoader";
import WiPdfMain from "./WiPdfMain";
import html2pdf from 'html2pdf.js';
import WiPdfTubeToTubesheet1 from "./WiPdfTubeToTubesheet1";
import WiPdfTubeToTubesheet2Hindi from "./WiPdfTubeToTubesheet2Hindi";
import WiPdfTubeToTubesheet3Hindi from "./WiPdfTubeToTubesheet3Hindi";
import WiPdf3Hindi from "./WiPdf3Hindi";
import WiPdf2Hindi from "./WiPdf2Hindi";
import { showWarning, showError } from "../../utility/ui/notifications/Toaster";


const WiPdfViewer = (props) => {
  const [loading, setLoading] = useState(true);
  const [printing, setPrinting] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfBlob, setPdfBlob] = useState(null);

  const generatePdfBlob = React.useCallback(async () => {
    setLoading(true);
    console.log("🔄 Starting PDF generation...");
    
    let tempContainer = null;
    try {
      // Initial delay for DOM setup
      await new Promise(resolve => {
        setTimeout(resolve, 200);
      });
      
      // Create temporary container dynamically - match grid PDF exactly
      tempContainer = document.createElement('div');
      tempContainer.id = 'TempPdfContainer';
      tempContainer.style.cssText = `
        display: none;
        width: 750px;
        background-color: white;
        font-family: Arial, sans-serif;
      `;
      
      document.body.appendChild(tempContainer);
      
      // Render React components into temporary container
      const istubesheet = props?.rowdata?.[1]?.wld_WPSType === "Tubesheet";
      
      const pdfContent = (
        <div>
          <br />
          {istubesheet ? (
            <>
              <WiPdfTubeToTubesheet1 rowdata={props?.rowdata} wpsde={props?.wpsde} />
              <div style={{ pageBreakInside: "avoid", paddingTop: "30px" }}>
                <WiPdfTubeToTubesheet2Hindi rowdata={props?.rowdata} wpsde={props?.wpsde} />
              </div>
              <div style={{ pageBreakInside: "avoid", paddingTop: "30px" }}>
                <WiPdfTubeToTubesheet3Hindi rowdata={props?.rowdata} wpsde={props?.wpsde} />
              </div>
            </>
          ) : (
            <>
              <WiPdfMain rowdata={props?.rowdata} wpsde={props?.wpsde} />
              <div style={{ pageBreakInside: "avoid", paddingTop: "30px" }}>
                <WiPdf2Hindi rowdata={props?.rowdata} wpsde={props?.wpsde} />
              </div>
              <div style={{ pageBreakInside: "avoid", paddingTop: "30px" }}>
                <WiPdf3Hindi rowdata={props?.rowdata} wpsde={props?.wpsde} />
              </div>
            </>
          )}
        </div>
      );
      
      // Render React content into temporary container
      ReactDOM.render(pdfContent, tempContainer);
      
      // Show for rendering only
      tempContainer.style.display = 'block';
      
      console.log('Element HTML length:', tempContainer.innerHTML.length);
      
      const options = {
        margin: [0, 0.5, 0, 0],
        html2canvas: { scale: 3 },
        jsPDF: { unit: 'in', format: "A4", orientation: 'portrait', compressPDF: true },
      };
      
      console.log("🎨 Generating PDF...");
      const pdfBlob = await html2pdf().set(options).from(tempContainer).outputPdf('blob');
      
      tempContainer.style.display = 'none';
      
      console.log("📦 PDF Blob size:", pdfBlob.size, "bytes");
      
      if (pdfBlob.size > 1000) {
        const url = URL.createObjectURL(pdfBlob);
        console.log("🔗 PDF URL:", url);
        setPdfUrl(url);
        setPdfBlob(pdfBlob);
      } else {
        throw new Error('PDF generation failed - empty content');
      }
      
    } catch (error) {
      console.error("❌ PDF Error:", error);
    } finally {
      // Always cleanup temporary container
      if (tempContainer && tempContainer.parentNode) {
        ReactDOM.unmountComponentAtNode(tempContainer);
        document.body.removeChild(tempContainer);
        console.log("🧹 Temporary container cleaned up");
      }
      setLoading(false);
    }
  }, [props?.rowdata, props?.wpsde]);

  useEffect(() => {
    if (props?.rowdata) {
      console.log("PDF Viewer - Data received:", { rowdata: props.rowdata });
      generatePdfBlob();
    } else {
      console.log("PDF Viewer - Missing data:", { rowdata: !!props?.rowdata });
      setLoading(false);
    }
  }, [props?.rowdata, generatePdfBlob]);

  useEffect(() => {
    return () => {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
      }
    };
  }, [pdfUrl]);

  const handlePrint = async () => {
    if (!pdfBlob) {
      showWarning('PDF not ready for printing');
      return;
    }
    
    setPrinting(true);
    try {
      // Create a blob URL for printing
      const printUrl = URL.createObjectURL(pdfBlob);
      
      // Open print dialog
      const printWindow = window.open(printUrl, '_blank');
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print();
          printWindow.onafterprint = () => {
            printWindow.close();
            URL.revokeObjectURL(printUrl);
          };
        };
      } else {
        // Fallback: create iframe for printing
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = printUrl;
        document.body.appendChild(iframe);
        
        iframe.onload = () => {
          iframe.contentWindow.print();
          setTimeout(() => {
            document.body.removeChild(iframe);
            URL.revokeObjectURL(printUrl);
          }, 1000);
        };
      }
    } catch (error) {
      console.error('Print error:', error);
      showError('Failed to print PDF');
    } finally {
      setPrinting(false);
    }
  };

  return (
    <>
      <Modal
        {...props}
        size="xl"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>WI Slip - {props?.rowdata?.[1]?.wld_WPSType}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh", padding: 0, overflow: 'hidden' }}>
          {loading ? (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', gap: '20px' }}>
              <BarLoader color="#810055" height={8} width={196} />
              <div>Generating PDF content...</div>
            </div>
          ) : pdfUrl ? (
            <iframe 
              src={`${pdfUrl}#toolbar=1&navpanes=0&scrollbar=1`}
              style={{ width: '100%', height: '100%', border: 'none' }}
              title="WI PDF Viewer"
            />
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', gap: '10px' }}>
              <div>Failed to generate PDF</div>
              <Button variant="outline-primary" onClick={generatePdfBlob}>
                Retry PDF Generation
              </Button>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button className="nobtn" onClick={props.onHide} style={{ width: '100px' }}>
            Close
          </Button>
          <Button variant="primary" onClick={handlePrint} disabled={loading || printing} style={{ width: '100px' }}>
            {printing ? 'Printing...' : 'Print'}
          </Button>
        </Modal.Footer>
      </Modal>

    </>
  );
};

export default WiPdfViewer;